var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: { title: "搜索条件", width: 1000, "footer-hide": "" },
          model: {
            value: _vm.mainTable.sarchCardShow,
            callback: function ($$v) {
              _vm.$set(_vm.mainTable, "sarchCardShow", $$v)
            },
            expression: "mainTable.sarchCardShow",
          },
        },
        [
          _c("search-card", {
            ref: "searchCard",
            attrs: {
              form: _vm.mainTable.searchForm,
              "table-load-event": _vm.getSaleStatList,
              "table-search": _vm.mainTable.tableSearch,
            },
          }),
        ],
        1
      ),
      _c(
        "Card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c(
                    "div",
                    { staticClass: "left-bar" },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("销售统计(发货单)"),
                      ]),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("统计时间:"),
                      ]),
                      _c("DatePicker", {
                        staticStyle: { "margin-left": "4px", width: "180px" },
                        attrs: {
                          type: "daterange",
                          size: "small",
                          transfer: "",
                          clearable: false,
                          placement: "bottom-end",
                          placeholder: "选择期初和期末时间",
                        },
                        on: { "on-change": _vm.onDateChange },
                        model: {
                          value: _vm.selectDates,
                          callback: function ($$v) {
                            _vm.selectDates = $$v
                          },
                          expression: "selectDates",
                        },
                      }),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("会员类别:"),
                      ]),
                      _c(
                        "RadioGroup",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            width: "210px",
                          },
                          on: { "on-change": _vm.onUserTypeChange },
                          model: {
                            value: _vm.userType,
                            callback: function ($$v) {
                              _vm.userType = $$v
                            },
                            expression: "userType",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: "F" } }, [
                            _c("span", [_vm._v("外部会员")]),
                          ]),
                          _c("Radio", { attrs: { label: "E" } }, [
                            _c("span", [_vm._v("内部会员")]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v("是否0价单:")]
                      ),
                      _c(
                        "RadioGroup",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            width: "120px",
                          },
                          on: { "on-change": _vm.onTotalOrderCostChange },
                          model: {
                            value: _vm.totalOrderCost,
                            callback: function ($$v) {
                              _vm.totalOrderCost = $$v
                            },
                            expression: "totalOrderCost",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: "0" } }, [
                            _c("span", [_vm._v("否")]),
                          ]),
                          _c("Radio", { attrs: { label: "1" } }, [
                            _c("span", [_vm._v("是")]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "RadioGroup",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "button", size: "small" },
                          on: { "on-change": _vm.onGroupByChange },
                          model: {
                            value: _vm.groupBy,
                            callback: function ($$v) {
                              _vm.groupBy = $$v
                            },
                            expression: "groupBy",
                          },
                        },
                        [
                          _c("Radio", { attrs: { label: "seedFarm" } }, [
                            _c("span", [_vm._v("苗场")]),
                          ]),
                          _c("Radio", { attrs: { label: "manager" } }, [
                            _c("span", [_vm._v("经理")]),
                          ]),
                          _c("Radio", { attrs: { label: "station" } }, [
                            _c("span", [_vm._v("转运站")]),
                          ]),
                          _c("Radio", { attrs: { label: "product" } }, [
                            _c("span", [_vm._v("商品")]),
                          ]),
                          _c("Radio", { attrs: { label: "member" } }, [
                            _c("span", [_vm._v("会员")]),
                          ]),
                          _c("Radio", { attrs: { label: "mainCate" } }, [
                            _c("span", [_vm._v("大类")]),
                          ]),
                          _c("Radio", { attrs: { label: "subCate" } }, [
                            _c("span", [_vm._v("小类")]),
                          ]),
                          _c("Radio", { attrs: { label: "province" } }, [
                            _c("span", [_vm._v("省")]),
                          ]),
                          _c("Radio", { attrs: { label: "city" } }, [
                            _c("span", [_vm._v("市")]),
                          ]),
                          _c("Radio", { attrs: { label: "dist" } }, [
                            _c("span", [_vm._v("区")]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "info",
                            size: "small",
                            shape: "circle",
                            icon: "ios-send",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onExport()
                            },
                          },
                        },
                        [_vm._v("导出")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("stand-pagination-table", {
                        attrs: {
                          columns: _vm.mainTable.statColumns,
                          data: _vm.mainTable.data,
                          loading: _vm.mainTable.loading,
                          "table-search": _vm.mainTable.tableSearch,
                          extHeight: -50,
                          "table-load-event": _vm.getSaleStatList,
                          showPage: false,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            title: "销售明细",
            width: 1200,
            closable: false,
            "footer-hide": "",
          },
          model: {
            value: _vm.combineStatDetail.show,
            callback: function ($$v) {
              _vm.$set(_vm.combineStatDetail, "show", $$v)
            },
            expression: "combineStatDetail.show",
          },
        },
        [
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c("Col", { attrs: { span: "24" } }, [
                    _c("div", { staticClass: "global-tool-bar" }, [
                      _c("div", { staticClass: "left-bar" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("销售明细列表"),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "right-bar" },
                        [
                          _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                type: "info",
                                size: "small",
                                shape: "circle",
                                icon: "ios-send",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onDetailExport()
                                },
                              },
                            },
                            [_vm._v("导出")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("stand-pagination-table", {
                        attrs: {
                          columns: _vm.combineStatDetail.preSaleColumns,
                          data: _vm.combineStatDetail.preSaleData,
                          loading: _vm.combineStatDetail.loading,
                          "table-search": _vm.combineStatDetail.tableSearch,
                          "table-load-event": _vm.showCombineStatDetail,
                          autoHeight: true,
                          showPage: true,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "div-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "Button",
                {
                  staticClass: "btn-font",
                  attrs: { type: "text" },
                  on: { click: _vm.cancal },
                },
                [_vm._v("✕")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }